import request from '@/utils/request'


// 查询工作类型列表
export function listWork(query) {
  return request({
    url: '/user/work-type/list',
    method: 'get',
    params: query
  })
}

// 查询工作类型分页
export function pageWork(query) {
  return request({
    url: '/user/work-type/page',
    method: 'get',
    params: query
  })
}

// 查询工作类型详细
export function getWork(data) {
  return request({
    url: '/user/work-type/detail',
    method: 'get',
    params: data
  })
}

// 新增工作类型
export function addWork(data) {
  return request({
    url: '/user/work-type/add',
    method: 'post',
    data: data
  })
}

// 修改工作类型
export function updateWork(data) {
  return request({
    url: '/user/work-type/edit',
    method: 'post',
    data: data
  })
}

// 删除工作类型
export function delWork(data) {
  return request({
    url: '/user/work-type/delete',
    method: 'post',
    data: data
  })
}
